import { useContext, useEffect, useRef, useState } from 'react';
import { useOutsideClickForTwoRef } from '../../../Hooks/useOutsideClickForTwoRef';
import ChevronDown from '../../../Assets/ChevronDownLargeDarkMode.svg';
import { InventoryAddProductFormContext } from '../../../Context/InventoryAddProductFormContext';
import TickMark from '../../../Assets/Modals/TickMark.svg';
import { getCollectionForCategory } from '../../../lib/utils/apiCalls';
import SearchIcon from '../../../Assets/OrderManagement/SearchIcon.svg';

function CollectionDropdown({ category }) {
    const collectionDropdownButtonRef = useRef(null);
    const collectionDropdownRef = useRef(null);
    const searchInputRef = useRef(null);

    useOutsideClickForTwoRef(collectionDropdownButtonRef, collectionDropdownRef, () => {
        setCollectionDropdownOpen(false);
        setSearchTerm('');
    });

    const { selectedCollections, setSelectedCollections } = useContext(InventoryAddProductFormContext);

    const [collection, setCollection] = useState([]);
    const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
    const [names, setNames] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const filteredCollection = collection.filter(item =>
        item.CollectionName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCollectionDropdownItemClick = (e, item) => {
        e.stopPropagation();
        let isSelected = selectedCollections.some(selected => selected.id === item.id);

        if (isSelected) {
            let filteredList = selectedCollections.filter(sel => sel.id !== item.id);
            setSelectedCollections(filteredList);
        } else {
            setSelectedCollections([...selectedCollections, item]);
        }
    };

    const toggleCollectionDropdown = () => {
        setCollectionDropdownOpen(!collectionDropdownOpen);
        if (!collectionDropdownOpen) {
            setTimeout(() => {
                searchInputRef.current?.focus();
            }, 100);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchClick = (e) => {
        e.stopPropagation();
    };

    useEffect(() => {
        const fetchCollections = async () => {
            try {
                const response = await getCollectionForCategory(category.id);
                setCollection(response.collection);
            } catch (err) {
                console.log(err);
            }
        };

        fetchCollections();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let arr = collection
            .filter(c => selectedCollections.some(selected => selected.id === c.id))
            .map(c => c.CollectionName);

        setNames(arr);
    }, [selectedCollections, collection]);

    return (
        <div className="flex flex-col gap-2">
            <h1 className='select-none cursor-pointer font-medium text-base text-[#121212]'>{category.categoryName} Collection</h1>

            <div ref={collectionDropdownButtonRef} onClick={toggleCollectionDropdown} className={`relative cursor-pointer px-3 py-4 border rounded-[9px] border-[#EAEAEA] bg-[#F5F5F5] flex items-center gap-[10px] ${collectionDropdownOpen && 'border-[#00c853]'}`}>
                <div className="w-[calc(100%-24px)]">
                    <p className='font-normal select-none text-base text-[#666666] whitespace-nowrap overflow-hidden text-ellipsis'>
                        {names.length > 0 ? names.join(', ') : 'Select'}
                    </p>
                </div>

                <div className="w-6 h-6 flex items-center justify-center select-none">
                    <img src={ChevronDown} alt="" />
                </div>

                {collectionDropdownOpen && (
                    <div ref={collectionDropdownRef} className="absolute z-10 top-[58px] left-0 w-full border border-[#EAEAEA] rounded-xl max-h-56 overflow-y-scroll bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]">

                        {/* 🔍 Search Bar */}
                        <div className="px-3 py-4 flex items-center gap-[10px] w-full border-b border-[#EAEAEA] sticky top-0 bg-[#FFFFFF]" onClick={handleSearchClick}>
                            <div className="w-6 h-6 flex items-center justify-center">
                                <img src={SearchIcon} alt="" />
                            </div>
                            <input
                                ref={searchInputRef}
                                type="text"
                                className='w-[calc(100%-24px)] outline-none'
                                placeholder='Search collection'
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>

                        {filteredCollection.length > 0 ? (
                            filteredCollection.map(item => {
                                let isSelected = selectedCollections.some(sel => sel.id === item.id);
                                return (
                                    <div key={item.id} onClick={(e) => handleCollectionDropdownItemClick(e, item)} className="w-full px-3 py-4 flex gap-[10px] bg-[#FFFFFF] hover:bg-[#F5F5F5]">
                                        <div className={`w-6 h-6 cursor-pointer rounded-md ${isSelected ? 'border-none bg-primaryAccent flex items-center justify-center' : 'border border-[#D1D5DB]'}`}>
                                            <img src={isSelected ? TickMark : undefined} alt="" />
                                        </div>
                                        <p className='font-medium select-none text-base text-[#666666]'>{item.CollectionName}</p>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="w-full px-3 py-4 text-center">
                                <p className='font-medium text-base text-[#999999] select-none'>No collections found</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default CollectionDropdown;
